export enum Alcances {
  Nacional = 1,
  Jurisdiccional = 2,
  Federal = 3,
}
